import React from "react";
import { useParams } from "react-router-dom";
import { getSupabaseBaseUrl } from "@/services/supabaseClient";

export default function ReferralDocumentRedirect() {
  const { token } = useParams();

  React.useEffect(() => {
    const cleanToken = String(token || "").trim();
    const baseUrl = getSupabaseBaseUrl();

    if (!cleanToken || !baseUrl) return;

    const target = `${baseUrl}/functions/v1/referral-redirect/${encodeURIComponent(cleanToken)}`;
    window.location.replace(target);
  }, [token]);

  return (
    <div className="min-h-screen bg-[rgb(var(--clr-background))] text-on-surface">
      <div className="afrimed-rail afrimed-rail--comfortable pt-8 pb-24">
        <div className="text-body-medium text-on-surface-var">Opening referral document…</div>
      </div>
    </div>
  );
}
